import { Observable } from 'rxjs';
import {
  BevHoldersQuery,
  BevHoldersResult,
} from '../models/site-bev-holders.model';

/**
 * An abstract class doubling as the DI token and the contract, so the implementation bound in
 * the route's `providers` can change with no caller change.
 */
export abstract class SiteBevHoldersRepository {
  /** One record per level, or `null` where the dataset has no coverage. */
  abstract getBevHolders(query: BevHoldersQuery): Observable<BevHoldersResult>;
}
